export default "__VITE_ASSET__d0xvP7jg7ArOC$z07Bjxkg__"